import { HttpResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AuxiliarService } from 'src/app/_services/auxiliar.service';
import { ViajesService } from 'src/app/_services/viajes.service';
import { ModalCategoriaHotelComponent } from '../modal-categoria-hotel/modal-categoria-hotel.component';
import { ModalMsgComponent } from '../modal-msg/modal-msg.component';
import {DomSanitizer } from '@angular/platform-browser';


interface Habitacion {
  name: string,
  value: string,
  check: boolean,
};

@Component({
  selector: 'app-tour-update',
  templateUrl: './tour-update.component.html',
  styleUrls: ['./tour-update.component.css']
})
export class TourUpdateComponent implements OnInit, OnDestroy {

  year: number;
  form1: FormGroup;
  form2: FormGroup;
  submitted2 = false;
  idViaje: string;
  //imagenesbd= [];
  //imagenes: any;
  //file = false;
  tipoTransporte: string;
  protected asientosSubscription: Subscription;
  asientos: string[];
  bdTransporte: any;
  passAsientos: string;
  bloqueado: number;
  asientosSelected: string[];
  protected categoriaSubscription: Subscription;
  categoria: number = 3;
  localUrl: any[];
  ext: string;
  file = false;
  checked = false;
  tipoHabitacion:  Habitacion[];  
  tipoCama = [];
  cama_simple = false;
  cama_doble =  false;
  id_hotel: string;
  showInput = true;
  estadoViaje: string;
  errorImagen: string;
  tieneItinerario: boolean;
  tieneExcursiones: boolean;
  dias:number[] = [];

  

  constructor(
    private formBuilder: FormBuilder,
    private viajesService: ViajesService,
    private auxService: AuxiliarService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    public domSrv: DomSanitizer,
    private chdRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    //obtener parametro de url
    this.idViaje = this.activatedRoute.snapshot.params.id;

    this.year = new Date().getFullYear();
    this.asientosSelected = [];
    this.asientos = [];
    this.bloqueado = 0;
    this.errorImagen = '';
    //obtener tipo transporte
    this.viajesService.getTipoTransporte().subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        var response = data.body;
        this.bdTransporte = response;                     
      }
    }); 
    
    this.form1 = this.formBuilder.group({      
      nombre: ['', Validators.required], 
      descripcion: ['', Validators.required],         
    });

    this.form2 = this.formBuilder.group({
      imagenes: this.formBuilder.array([], [Validators.required]),
      destino: ['', Validators.required], 
      mes: ['default'],
      anno: ['default'],  
      dia:['default'],
      salida: ['', Validators.required],
      noches: ['', Validators.required],
      detalles: ['', Validators.required],         
      desde: ['', Validators.required],
      hasta: ['', Validators.required],
      transporte: ['default'], 
      hotel: ['', Validators.required], 
      //imagen:  [],
      checkHabitacion: this.formBuilder.array([], [Validators.required]),
      checkCama: this.formBuilder.array([], [Validators.required]),
      Individual: ['', Validators.required],
      Doble:['', Validators.required],
      Triple:['', Validators.required],
      Cuadruple:['', Validators.required],
    }, { validators: [
        this.ConfirmedValidator('mes', 'anno','dia'), 
        this.transporteValidator('transporte'),
        this.rangoEdadValidator('desde', 'hasta'),
        this.precioValidator('Individual'),
        this.precioValidator('Doble'),
        this.precioValidator('Triple'),
        this.precioValidator('Cuadruple')
      ]}
    );

    this.form2.get("mes").valueChanges.subscribe(value=>{
      var lastValue = (value == 1 || value == 3 || value == 5 || value == 7 || value == 8 || value == 10 || value == 12) ? 31 : 30;
      if(value == 2){
        lastValue = 28;
      }
      for(var i = 1; i <= lastValue; i++){
        this.dias.push(i);
        this.chdRef.detectChanges();
      }
    })

    this.asientosSubscription = this.viajesService.asientos.subscribe((data: any) => { 
      this.asientos = data;    
    });
    this.categoriaSubscription = this.viajesService.categoria_hotel.subscribe((data: any) => { 
      this.categoria = data;    
    });
    //obtener tipo de habitacion
    this.viajesService.getTipoHabitacion().subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        if(data.body.length > 0){
          var habitaciones = data.body;   
          var list= [];
          for (let i in habitaciones) {                     
            list.push({ name: habitaciones[i].tipo, value: habitaciones[i].id, check: false });                      
          } 
          this.tipoHabitacion = list;
        }    
      }
    }); 
    //obtener tipo de cama
    this.viajesService.getTipoCama().subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        if(data.body.length > 0){
          var tipoCamas = data.body;   
          var list= [];
          for (let i in tipoCamas) { 
            list.push({ name: tipoCamas[i].tipo, value: tipoCamas[i].id });                      
          } 
          this.tipoCama = list;
        }    
      }
    });   
    //saber si tiene itinerario
    this.viajesService.tieneItinerario(this.idViaje).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body > 0){
          this.tieneItinerario = true;
        }    
        else {
          this.tieneItinerario = false;
        }        
      }
    });  
    //saber si tiene excursiones
    this.viajesService.tieneExcursiones(this.idViaje).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body > 0){
          this.tieneExcursiones = true;
        }    
        else {
          this.tieneExcursiones = false;
        }        
      }
    });    

    //recuperar datos
    this.cargarDatosViaje();
    
  }
  
  ConfirmedValidator(controlName1: string, controlName2: string, controlName3: string){
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName1];
        const control1 = formGroup.controls[controlName2];
        const control2 = formGroup.controls[controlName3];        
        if ( control.value === "default" || control1.value === "default" || control2.value === "default") {
            control.setErrors({ confirmedValidator: true });
        } 
        else { 
          control.setErrors(null);
        }
    }   
  }
  
  rangoEdadValidator(controlName1: string, controlName2: string){
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName1];
      const control1 = formGroup.controls[controlName2];        
      if ( (control.value !== '') && (control1.value !== '') && (parseInt(control.value) > 20 || parseInt(control.value) < 0) 
            || (parseInt(control1.value) > 20 || parseInt(control1.value) < 0)
            || (parseInt(control.value) >= parseInt(control1.value))) {
          control1.setErrors({ rangoEdadValidator: true });
      } /*
      else { 
        control.setErrors(null);
      }*/
    }   
  }
  transporteValidator(controlName: string){
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      if (control.value === "default") {
        control.setErrors({ transporteValidator: true });
      } else { 
        control.setErrors(null);
      }  
    }   
  }
  precioValidator(controlName: string){
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      if (control.value  < 1) {
        control.setErrors({ precioValidator: true });
      } else { 
        control.setErrors(null);
      } 
    }
  }
 
  keypressValue(event){
    var k;
    k = event.charCode;
    return ((k >= 48 && k <= 57));
  }
  obtenerImagenesBD(){
    this.viajesService.getImagenes(this.idViaje, '0').subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        if(data.body.length > 0){
          var img = data.body;
         // this.imagenesbd = [];          
          for (let i in img) {                       
            this.imagenes.push(this.createItem({                    
              //ext: ext,
              url: img[i].imagen  //Base64 string for preview image
            }));            
          }                 
        } 
      }
    });
  }
  cargarDatosViaje(){
    this.obtenerImagenesBD();
    this.viajesService.get(this.idViaje).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        var response = data.body;
        //obtener estado del paquete
        this.estadoViaje = response.id_estado;
        //trabajar fecha         
        var mes;
        var anno;
        var dia;
        if(response.fecha !== null && response.fecha !== undefined && response.fecha !== ''){
          mes = new Date(response.fecha).getMonth()+1;
          anno = new Date(response.fecha).getFullYear();
          dia = new Date(response.fecha).getDate();
        } else {
          mes = 'default';
          anno = 'default';   
          dia = 'default';       
        }        
        
        //trabajar transporte
        if(response.id_tipoBus !== null) {
          this.tipoTransporte = response.id_tipoBus.tipo;
          this.form2.patchValue({            
            transporte: this.getValue(response.id_tipoBus.id),
          });    
        }         
        this.passAsientos = response.asientos;
        this.form1.patchValue({
          nombre: this.getValue(response.nombre_paquete),
          descripcion: this.getValue(response.descripcion),
        }); 
        this.form2.patchValue({
          destino: this.getValue(response.destino),
          salida: this.getValue(response.lugar_salida),
          noches: this.getValue(response.cantidad_noches),
          detalles: this.getValue(response.properties_paquete),
          desde:this.getValue(response.edad_desde),
          hasta: this.getValue(response.edad_hasta),
          mes: mes,
          anno: anno,       
          dia: dia   
        });   
        //obtener datos del Hotel
        if(response.id_hotel !== null){
          this.id_hotel = response.id_hotel;
          this.viajesService.getHotel(response.id_hotel).subscribe(data => {
            if(data instanceof HttpResponse) {
              //verificar token
              if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
                this.auxService.sessionExpired();
              }
              //acciones
              var response = data.body.data;
              this.categoria = parseInt(response.categoria_hotel);
              var habitaciones = response.habitaciones;
              const checkHabitacion: FormArray = this.form2.get('checkHabitacion') as FormArray;
              for(let i in habitaciones){  
                checkHabitacion.push(new FormControl(habitaciones[i].id));
                for(let j in this.tipoHabitacion){
                  if(this.tipoHabitacion[j].value == habitaciones[i].id){
                    this.tipoHabitacion[j].check = true;   
                    if(this.tipoHabitacion[j].name === 'Individual'){
                      this.form2.patchValue({
                        Individual: this.getValue(habitaciones[i].precio)                    
                      }); 
                    }  
                    if(this.tipoHabitacion[j].name === 'Doble'){
                      this.form2.patchValue({
                        Doble: this.getValue(habitaciones[i].precio)                    
                      }); 
                    }  
                    if(this.tipoHabitacion[j].name === 'Triple'){
                      this.form2.patchValue({
                        Triple: this.getValue(habitaciones[i].precio)                    
                      }); 
                    }   
                    if(this.tipoHabitacion[j].name === 'Cuadruple'){
                      this.form2.patchValue({
                        Cuadruple: this.getValue(habitaciones[i].precio)                    
                      }); 
                    }       
                  }  
                } 
              }
              const checkCama: FormArray = this.form2.get('checkCama') as FormArray;
              if(response.cama_simple === 1) {
                checkCama.push(new FormControl("1"));
                this.cama_simple = true;
              }
              if(response.cama_doble === 1) {
                checkCama.push(new FormControl("2"));
                this.cama_doble = true;
              }
              if(response.imagen_hotel !== null && response.imagen_hotel !== undefined && response.imagen_hotel !== ''){
                this.file = true;
                this.localUrl = response.imagen;
              }            
              this.form2.patchValue({
                hotel: this.getValue(response.nombre_hotel)                    
              });   
            }
          });
        } else {
          //mostrar habitaciones por defecto
          const checkHabitacion: FormArray = this.form2.get('checkHabitacion') as FormArray;
          checkHabitacion.push(new FormControl(["1", "2"]));
          for(let i in this.tipoHabitacion){
            if(this.tipoHabitacion[i].name === 'Individual' || this.tipoHabitacion[i].name === 'Doble')
              this.tipoHabitacion[i].check = true;   
          }
        }
      }            
    });   
  }

  getValue(cadena: string){
    return (cadena !== null || cadena !== undefined)?cadena:'';
  }
  

  get f() { return this.form1.controls; }
  get f1() { return this.form2.controls; }
  

  //Help to get all photos controls as form array.
  get imagenes(): FormArray {
    return this.form2.get('imagenes') as FormArray;
  };
  // We will create multiple form controls inside defined form controls photos.
  createItem(data): FormGroup {
    return this.formBuilder.group(data);
  }
  deleteItem(data){
    this.imagenes.removeAt(data);
  }

  fileEvent(fileInput: any){    
    let files = fileInput.target.files;
    if (files) {
      for (let file of files) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.imagenes.push(this.createItem({                    
                  ext: file.name.split('.')[1],
                  url: e.target.result  //Base64 string for preview image
                }));
        }
        reader.readAsDataURL(file);
      }
      if(this.showInput) {
        this.showInput = false;
       } else { 
        this.showInput = true;
       }
    }
  }
  changeTransporte(){
    for (let i in this.bdTransporte){
      if(this.bdTransporte[i].id == this.form2.get('transporte').value){
        this.tipoTransporte = this.bdTransporte[i].tipo;  
        //this.passAsientos = this.bdTransporte[i].asientos_ocupados;
        return;
      }
    }    
  }

  fileEvent2(fileInput: any){
    /*if (fileInput.target.files.length > 0) {
      const file = fileInput.target.files[0];
      this.ext = file.name.split('.')[1];
      this.form2.get('imagen').setValue(file);
      this.errorImagen = '';
    }    
    var reader = new FileReader();
     reader.onload = (fileInput: any) => {
         this.localUrl = fileInput.target.result  
         this.file = true;                      
     }
   reader.readAsDataURL(fileInput.target.files[0]);  */
  } 
  
  habilitarControlesOcultos(){
    //Probar habiitar todos los controles ocultos
    this.f1.Individual.enable();
    this.f1.Doble.enable();
    this.f1.Triple.enable();
    this.f1.Cuadruple.enable();
  }
 
  onSubmit2() { 
    this.submitted2 = true;
    
    //Deshabilitar controles ocultos
    for (let i in this.tipoHabitacion){
      if(!this.tipoHabitacion[i].check){
        if(this.tipoHabitacion[i].name === 'Individual'){
          this.f1.Individual.disable();
        }
        if(this.tipoHabitacion[i].name === 'Doble'){
          this.f1.Doble.disable();
        }
        if(this.tipoHabitacion[i].name === 'Triple'){
          this.f1.Triple.disable();
        }
        if(this.tipoHabitacion[i].name === 'Cuadruple'){
          this.f1.Cuadruple.disable();
        }
      }      
    }
   
    // stop here if form is invalid
    /*if (this.form2.invalid || this.form1.invalid || (this.f1.imagen.value === null && !this.file)) {
      if(this.f1.imagen.value === null && !this.file){
        this.errorImagen = 'Imagen es requerida';
      }
      this.habilitarControlesOcultos();
      return;
    }*/    
    if (this.form2.invalid || this.form1.invalid) {
      this.habilitarControlesOcultos();
      return;
    }
    
    //guardar las imágenes del viaje
    if(this.imagenes.length > 0 && this.idViaje !=='0'){
      this.viajesService.insertarImagen(this.idViaje,'0',this.form2.value).subscribe(data => {
        if(data instanceof HttpResponse) {
          //verificar token
          if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
            this.auxService.sessionExpired();
          }
          //acciones          
        }        
      });
    }
    //obtener precios de habitaciones
    var list=[]; 
    for (let i in this.tipoHabitacion){          
      if(this.tipoHabitacion[i].check){        
        if(this.tipoHabitacion[i].name === 'Individual'){
          var habitacion = {
            tipo_habitacion: this.tipoHabitacion[i].value,
            precio: this.f1.Individual.value       
          }
          list.push(habitacion);
        }
        if(this.tipoHabitacion[i].name === 'Doble'){
          var habitacion = {
            tipo_habitacion: this.tipoHabitacion[i].value,
            precio: this.f1.Doble.value         
          }
          list.push(habitacion);
        }
        if(this.tipoHabitacion[i].name === 'Triple'){
          var habitacion = {
            tipo_habitacion: this.tipoHabitacion[i].value,
            precio: this.f1.Triple.value        
          }
          list.push(habitacion);
        }
        if(this.tipoHabitacion[i].name === 'Cuadruple'){
          var habitacion = {
            tipo_habitacion: this.tipoHabitacion[i].value,
            precio: this.f1.Cuadruple.value       
          }
          list.push(habitacion);
        }
      }      
    }    
    //guardar el hotel
    //this.viajesService.updateHotel(this.id_hotel, this.f1.hotel.value , this.categoria.toString(), this.f1.checkCama.value, this.f1.imagen.value).subscribe(data => {
    this.viajesService.updateHotel(this.id_hotel, this.f1.hotel.value , this.categoria.toString(), this.f1.checkCama.value).subscribe(data => {
      if(data instanceof HttpResponse) { 
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        this.viajesService.deleteHabitaciones(this.id_hotel).subscribe(data => {
          if(data instanceof HttpResponse) { 
            this.viajesService.insertarHabitaciones(this.id_hotel, list).subscribe(data => {
              if(data instanceof HttpResponse) {}    
            }); 
          }
        });
      }    
    }); 
    var cadena=this.asientos.join('*');
    this.viajesService.updateAll(this.idViaje, this.f.nombre.value, this.f.descripcion.value, this.f1.destino.value , this.f1.dia.value,this.f1.mes.value, this.f1.anno.value, this.f1.salida.value, this.f1.noches.value,
      this.f1.detalles.value, this.f1.desde.value, this.f1.hasta.value, this.f1.transporte.value, cadena, this.id_hotel, "1").subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones        
        const modalRef = this.modalService.open(ModalMsgComponent, { 
          centered: true,  
          backdrop:'static',      
        });
        if(this.estadoViaje == "2"){          
          modalRef.componentInstance.titulo = 'Viaje guardado';
        } else {         
          modalRef.componentInstance.titulo = 'Viaje modificado';
        }   
        modalRef.componentInstance.check = 1; 
        modalRef.componentInstance.label = 'Volver';
        modalRef.componentInstance.padre = 'viajes';
        
        this.estadoViaje = "1";
      }    
    });
    this.habilitarControlesOcultos();  
  }

  updateDataTemp(ruta: number){
    
    //obtener precios de habitaciones
    var list=[]; 
    for (let i in this.tipoHabitacion){          
      if(this.tipoHabitacion[i].check){        
        if(this.tipoHabitacion[i].name === 'Individual'){
          var habitacion = {
            tipo_habitacion: this.tipoHabitacion[i].value,
            precio: this.f1.Individual.value       
          }
          list.push(habitacion);
        }
        if(this.tipoHabitacion[i].name === 'Doble'){
          var habitacion = {
            tipo_habitacion: this.tipoHabitacion[i].value,
            precio: this.f1.Doble.value         
          }
          list.push(habitacion);
        }
        if(this.tipoHabitacion[i].name === 'Triple'){
          var habitacion = {
            tipo_habitacion: this.tipoHabitacion[i].value,
            precio: this.f1.Triple.value        
          }
          list.push(habitacion);
        }
        if(this.tipoHabitacion[i].name === 'Cuadruple'){
          var habitacion = {
            tipo_habitacion: this.tipoHabitacion[i].value,
            precio: this.f1.Cuadruple.value       
          }
          list.push(habitacion);
        }
      }      
    }    
    //guardar el hotel
    //this.viajesService.updateHotel(this.id_hotel, this.f1.hotel.value , this.categoria.toString(), this.f1.checkCama.value, this.f1.imagen.value).subscribe(data => {
    this.viajesService.updateHotel(this.id_hotel, this.f1.hotel.value , this.categoria.toString(), this.f1.checkCama.value).subscribe(data => {
      if(data instanceof HttpResponse) { 
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        this.viajesService.deleteHabitaciones(this.id_hotel).subscribe(data => {
          if(data instanceof HttpResponse) { 
            this.viajesService.insertarHabitaciones(this.id_hotel, list).subscribe(data => {
              if(data instanceof HttpResponse) {}    
            }); 
          }
        });
      }    
    }); 
    var cadena=this.asientos.join('*');
    var tipoTransporte=(this.f1.transporte.value === 'default')?4:this.f1.transporte.value;
    this.viajesService.updateAll(this.idViaje, this.f.nombre.value, this.f.descripcion.value, this.f1.destino.value , this.f1.dia.value,this.f1.mes.value, this.f1.anno.value, this.f1.salida.value, this.f1.noches.value,
      this.f1.detalles.value, this.f1.desde.value, this.f1.hasta.value, tipoTransporte, cadena, this.id_hotel, "2").subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        } 
        //guardar las imágenes del viaje
        if(this.imagenes.length > 0 && this.idViaje !=='0'){
          this.viajesService.insertarImagen(this.idViaje,'0',this.form2.value).subscribe(data => {
            if(data instanceof HttpResponse) {          
              var response = data.body; 
              if(response.msg === "IMAGENES_SAVED") { 
                if(ruta === 1)
                  this.router.navigate(['/', 'admin', 'tour-itinerario', this.idViaje]);   
                else  this.router.navigate(['/', 'admin', 'tour-excursiones', this.idViaje]);
              }          
            }        
          });
        } else {
          if(ruta === 1)
            this.router.navigate(['/', 'admin', 'tour-itinerario', this.idViaje]);   
          else  this.router.navigate(['/', 'admin', 'tour-excursiones', this.idViaje]);      
        }         
      }    
    });

  }

  navItinerario(){
    if (this.estadoViaje == "2"){
      this.updateDataTemp(1);
    } else {      
      this.router.navigate(['/', 'admin', 'tour-itinerario', this.idViaje]);
    }    
  }
  navExcursiones(){
    if (this.estadoViaje == "2"){
      this.updateDataTemp(2);
    } else {      
      this.router.navigate(['/', 'admin', 'tour-excursiones', this.idViaje]);
    }       
  }
  navVolver(){    
    if (this.estadoViaje == "2"){ //eliminar paquete y regresar al admin      
      this.viajesService.deletePaquete(this.idViaje).subscribe(data => {
        if(data instanceof HttpResponse) { 
          this.router.navigate(['/', 'admin', 'packs']);
        }
      });      
    } else {      
      this.router.navigate(['/', 'admin', 'packs']);
    }  
  }

  openCategoria() {
    const modalRef = this.modalService.open(ModalCategoriaHotelComponent, { 
      centered: true,  
      backdrop:'static',      
    });       
  }

  onCheckboxChange(e) {
    const checkHabitacion: FormArray = this.form2.get('checkHabitacion') as FormArray;
  
    if (e.target.checked) {
      checkHabitacion.push(new FormControl(e.target.value));
      for(let i in this.tipoHabitacion){        
        if(this.tipoHabitacion[i].value == e.target.value){
          this.tipoHabitacion[i].check = true;          
        }        
      }
      
    } else {
      for(let i in this.tipoHabitacion){
        if(this.tipoHabitacion[i].value ==e.target.value){
          this.tipoHabitacion[i].check = false;          
        }        
      }
      
      let i: number = 0;
      checkHabitacion.controls.forEach((item: FormControl) => {
        if (item.value == e.target.value) {
          checkHabitacion.removeAt(i);
          return;
        }
        i++;
      });
    } 
    
  }
  onCheckboxChange1(e) {
    const checkCama: FormArray = this.form2.get('checkCama') as FormArray;
  
    if (e.target.checked) {
      checkCama.push(new FormControl(e.target.value));   
    } else {
      let i: number = 0;
      checkCama.controls.forEach((item: FormControl) => {
        if (item.value == e.target.value) {
          checkCama.removeAt(i);
          return;
        }
        i++;
      });
    }    
  }
  hasError(group:FormGroup, control:string) {
    return group.get(control).errors;    
  }
  requiredError(group:FormGroup, control:string) {
     return group.get(control).hasError('required');    
  }
  precioError(group:FormGroup, control:string) {
    return group.get(control).hasError('precioValidator');    
  }

  ngOnDestroy(): void {
    if(this.asientosSubscription){
       this.asientosSubscription.unsubscribe();
    } 
    if(this.categoriaSubscription){
      this.categoriaSubscription.unsubscribe();
   }
  }


}
